class RouteCollection extends App.Collections.BaseCollection {
  url = "Route";
  model = App.Models.Route;
}

App.Collections.Routes = RouteCollection;
